/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RecoveryCashOnDeliveryDataForCreationRequest } from '../../models/recovery-cash-on-delivery-data-for-creation-request';
import { RecoveryCashOnDeliveryDataForCreationResponse } from '../../models/recovery-cash-on-delivery-data-for-creation-response';

export interface PostFeV1RecoveryCodsDataForCreation$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
      body?: RecoveryCashOnDeliveryDataForCreationRequest
}

export function postFeV1RecoveryCodsDataForCreation$Plain(http: HttpClient, rootUrl: string, params?: PostFeV1RecoveryCodsDataForCreation$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RecoveryCashOnDeliveryDataForCreationResponse>> {
  const rb = new RequestBuilder(rootUrl, postFeV1RecoveryCodsDataForCreation$Plain.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecoveryCashOnDeliveryDataForCreationResponse>;
    })
  );
}

postFeV1RecoveryCodsDataForCreation$Plain.PATH = '/v1/recovery-cash-on-deliveries/data-for-creation';
